/**
 * Asteroid mix configurations
 *
 * This file is auto-generated by the balance importer.
 * Do not edit manually - changes will be overwritten.
 *
 * Generated at: 2025-09-25T12:43:18.992Z
 */

import { ConfigType } from './ConfigType';

export interface AsteroidMixConfig {
  asteroid_mix_id: string;
  name: string;
  notes: Record<string, any>;
  configType: ConfigType.ASTEROID_MIXES;
}

export const asteroidMixData: Record<string, AsteroidMixConfig> = {
  MIX_AURORA: {
    asteroid_mix_id: 'MIX_AURORA',
    name: 'Aurora Belt',
    notes: ['стартовый пояс', 'камень + чуть кварца', 'редкие вены'],
    configType: ConfigType.ASTEROID_MIXES,
  },
  MIX_FLUX: {
    asteroid_mix_id: 'MIX_FLUX',
    name: 'Flux Rift',
    notes: ['кварц+ферро', 'базальт как разбавитель'],
    configType: ConfigType.ASTEROID_MIXES,
  },
  MIX_LUMEN: {
    asteroid_mix_id: 'MIX_LUMEN',
    name: 'Lumen Forge',
    notes: ['люменит+ферро', 'немного кварца и редкие вены'],
    configType: ConfigType.ASTEROID_MIXES,
  },
};

/**
 * Get AsteroidMixConfig by asteroid_mix_id
 */
export function getAsteroidMix(id: string): AsteroidMixConfig | undefined {
  return asteroidMixData[id];
}

/**
 * Get all AsteroidMixConfig entries
 */
export function getAllAsteroidMix(): AsteroidMixConfig[] {
  return Object.values(asteroidMixData);
}

/**
 * Check if AsteroidMixConfig exists
 */
export function hasAsteroidMix(id: string): boolean {
  return id in asteroidMixData;
}
